export default {
  back: {
    id: 'rm_journey_back',
    defaultMessage: 'Back',
  },
  exit: {
    id: 'rm_journey_exit',
    defaultMessage: 'Leave the journey',
  },
  stripLabel: {
    id: 'rm_journey_strip_label',
    defaultMessage: 'Journey stops',
  },
  stepProgress: {
    id: 'rm_journey_step_progress',
    defaultMessage: 'Stop {current} of {total}',
  },
} as const
